<div class="container  no-padding min-height-100">
    <div class="d-flex justify-content-center mt-5 mb-5">
        <div class="row col-12 d-flex justify-content-center mt-4  no-padding">
            <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding"
                style="color: #000000;">

                <div class=" col-12 col-md-12 mb-3">
                    <div class="row d-flex justify-content-center">
                        <div class="col-8 col-md-10">
                            <mat-form-field class="col-12" appearance="outline">
                                <mat-label style="color:black">Buscar</mat-label>
                                <input [(ngModel)]="searchText" (keyup)="keyPress()" type="text" matInput
                                    placeholder="busca por producto">
                                <mat-icon matSuffix *ngIf="!searchText">search</mat-icon>
                                <button mat-button mat-icon-button matSuffix (click)="clearSearchField()"
                                    *ngIf="searchText">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>


                        <!-- <div class="col-3 col-md-2">

                            <button (click)="openInfo()" class="col-12 btn-primary" mat-raised-button
                                style="margin-top: 10px;">
                                <mat-icon>info</mat-icon>
                            </button>
                        </div> -->



                    </div>
                </div>



            </div>
            <div class="col-12 row d-flex justify-content-center no-padding">




                <div class="col-12 col-md-12 d-flex justify-content-center mb-2">
                    <div class="col-8 col-md-3 ">
                        <img src="../../../assets/texts/buy-to-product.svg" style="width: 100%" alt="">
                    </div>

                </div>


                <div *ngIf="loading" class=" row col-12 d-flex justify-content-center mt-5">
                    <app-spinner-loading></app-spinner-loading>
                </div>

                <app-div-no-result *ngIf="!products.length"></app-div-no-result>

                <div *ngFor=" let product of products" class="col-12 mt-2 mb-2  ">
                    <app-card-product class="d-flex justify-content-center" [product]="product"></app-card-product>
                </div>

                <div [ngClass]="disableButton()?'inVisibleButtonCheckOut':'visibleButtonCheckOut' "
                    class="  col-12 col-md-8 col-lg-6 col-xl-6 d-flex justify-content-center mt-5 mb-5">
                    <button mat-raised-button class="col-12" color="warn" [disabled]="disableButton()"
                        (click)="openTypePay()">
                        <!-- (click)="checkout()" -->
                        <mat-icon>shopping_cart</mat-icon> Ir a Pagar
                        <!-- : {{totalCart+totalService|number}} -->


                    </button>
                </div>

            </div>

        </div>

    </div>


    <div class=" buttomMenu shadow-div text-center " style="    display: flex;
justify-content: center;
align-items: center;">

        <div class="col-12">
            <button (click)="openInfo()" color="primary" mat-mini-fab aria-label="" class="col-12 no-shadow   ">
                <mat-icon class="no-margin no-padding">info</mat-icon>

            </button>
            <p style="    font-size: 11px;
            margin-top: -6px      ;" class="text-center">Info</p>
        </div>



    </div>